import furniture from "./furniture";
import tents from "./tents";
import sleeping from "./sleeping";

const all = [...furniture, ...tents, ...sleeping];

export default all;
